import { progressiveVanillaSelector } from '../selectors';
import type { Site } from '../Site';

export const GolfMonthly: Site = {
  id: 'golfmonthly',
  logo: 'svg/golfmonthly.svg',
  label: 'Golf Monthly',
  analyticsName: 'golfmonthly',
  hostname: 'golfmonthly.com',
  platform: 'progressive',
  selector: `${progressiveVanillaSelector}, #content a`,
};
